<template>
    <CContainer fluid>
      <h3>Formulario Cotizaci&oacute;n</h3>
      <CCard class="mt-4">
        <CCardHeader class="pt-5 px-3 pb-3">
          <CForm>
            <CRow>
              <CCol sm="6">
                <CCol sm="12">
                  <CAutocomplete
                    label="Cliente: "
                    required
                    :disabled="cart.items.length > 0 || !isCreate"
                    :options="directory"
                    :value.sync="quoteForm['directorio']"
                    @update:input="(newValue) => {
                      quoteForm['directorio'] = newValue
                      quoteForm['dependencia'] = ''
                      getDependencies(newValue)
                    }"
                    @update-search="(value) => getDirectoryData(value)">
                  </CAutocomplete>
                </CCol>
                <CCol sm="10" class="d-inline-block">
                  <CAutocomplete
                    label="Dependencia / CenCos:"
                    required
                    :disabled="!isCreate"
                    :options="dependencies"
                    :value.sync="quoteForm['dependencia']"
                    @update:input="newValue => {
                      quoteForm['dependencia'] = newValue }">
                  </CAutocomplete>
                </CCol>
                <CCol sm="2" class="d-inline-block">
                  <CButton 
                    color="success" 
                    variant="outline" 
                    :disabled="!quoteForm['directorio']"
                    @click="event => openRightSidebarDependency(event)">
                    <i class="bi bi-journal-plus h4"></i>
                  </CButton>
                </CCol>
                <CCol sm="4" class="d-inline-block">
                  <CInput
                    type="text"
                    label="Días Validez:"
                    addLabelClasses="text-muted font-weight-bold text-capitalize"
                    :value.sync="quoteForm['Dias_Validez']"
                    @update:value="(value) => {}" />
                </CCol>
                <CCol sm="4" class="d-inline-block">
                  <span class="text-muted font-weight-bold text-capitalize">Fecha Validez</span>
                  <p class="mt-3">
                    <strong>{{ dateValid }}</strong>
                  </p>
                </CCol>
                <CCol sm="4" class="d-inline-block">
                  <CButton 
                    color="info"
                    variant="outline"
                    class="position-relative"
                    :disabled="quoteForm['directorio'].length < 1" 
                    @click="eMailsModal = true">
                    <CIcon name="cil-envelope-closed"></CIcon>
                    <CBadge 
                      color="danger" 
                      position="top-end" 
                      shape="rounded-pill" 
                      class="px-2 ml-2">
                      {{ additionalseMails.length }}
                    </CBadge>
                  </CButton>
                </CCol>
              </CCol>
              <CCol sm="6">
                <CRow class="align-self-center">
                  <CCol class="mr-3 mb-3">
                    <CRow class="font-weight-bold"><CCol sm="6">Vr. Mercancia:</CCol><CCol align="right" sm="6">${{formatter.format(productsCost)}}</CCol></CRow>
                    <CRow class="font-weight-bold"><CCol sm="6">Vr. IVA:</CCol><CCol align="right" sm="6">${{formatter.format(IVACost)}}</CCol></CRow>
                    <CRow class="font-weight-bold"><CCol sm="6">Vr. ImpConsumo:</CCol><CCol align="right" sm="6">${{formatter.format(consTax)}}</CCol></CRow>
                    <!-- <CRow class="font-weight-bold" style="font-size:1.5em"><CCol sm="6">Total Cotización: </CCol><CCol align="right" sm="6">${{formatter.format(cart.productsCost + cart.IVACost + cart.consTax, 0)}}</CCol></CRow> -->
                    <CRow class="font-weight-bold" style="font-size:1.5em"><CCol sm="6">Total Cotización: </CCol><CCol align="right" sm="6">${{formatter.format(totalCost, 0)}}</CCol></CRow>
                  </CCol>
                </CRow>
                <CRow class="mt-3 mr-1 d-flex justify-content-end">
                  <div class="mx-2">
                    <CButton 
                      color="success" 
                      :disabled="(cartSize == 0) || (quoteForm['directorio'].length < 1)" 
                      :class="(cartSize == 0) ? 'disabled' : ''"
                      @click="confirmationModal = true">
                      <CIcon name="cil-check-circle"/>
                      <span class="p-2 align-middle">Guardar</span>
                    </CButton>
                    <p>
                      <span v-if="(cartSize == 0)" class="text-danger" style="font-size:0.5em;">
                        * No hay productos en el carrito
                      </span>
                    </p>
                  </div>
                  <div class="mx-2">
                    <CButton
                      color="danger"
                      variant="outline"
                      @click="resetCart()">
                      <CIcon name="cil-x-circle"></CIcon>
                      <span class="p-2 align-middle">Cancelar</span>
                    </CButton>
                  </div>
                </CRow>
              </CCol>
            </CRow>
            <CRow>
              <CCol col="sm-12" class="d-flex">
                <CInput
                  label="Comentarios:"
                  addLabelClasses="text-muted font-weight-bold text-capitalize"
                  class="col-sm-12"
                  maxlength="100"
                  :value.sync="comments1"
                  @update:value="() => {}">
                  <i class="bi bi-blockquote-left"></i>
                </CInput>
                <span class="text-danger mt-5" style="font-size: xx-small;">
                  {{ 100 - comments1.length}}
                </span>
              </CCol>
              <CCol col="sm-12" class="d-flex">
                <CInput
                  addLabelClasses="text-muted font-weight-bold text-capitalize"
                  class="col-sm-12"
                  maxlength="100"
                  :value.sync="comments2"
                  @update:value="() => {}" />
                <span class="text-danger mt-4" style="font-size: xx-small;">
                  {{ 100 - comments2.length}}
                </span>
              </CCol>
            </CRow>
          </CForm>
        </CCardHeader>

        <CCardBody>
          <CRow>
            <CCol sm="12">
              <CAutocomplete
                label="Producto"
                class="col-sm-6 d-inline-block"
                :disabled="!quoteForm['directorio']"
                :required="null"
                :options="productsList"
                :value.sync="selectedProductId"
                @update:input="newValue => {
                  selectedProductId = newValue
                  getProduct()
                }"
                @update-search="value => getProductsList(value)" >
              </CAutocomplete>
              <i 
                class="bi bi-info-circle h4"
                v-c-tooltip="{
                  html: true,
                  placement: 'top-end',
                  content: `${selectedProductDetail}`
                }">
              </i>
              <CInput
                type="number"
                label="Cantidad"
                class="col-sm-2 d-inline-block"
                addLabelClasses="text-muted font-weight-bold text-capitalize"
                :class="!selectedProductId ? 'disabled' : ''"
                :disabled="!selectedProductId"
                :value.sync="selectedProductQty"
                @update:value="() => {}" 
              />
              <CInput
                type="text"
                label="Valor"
                class="col-sm-2 d-inline-block"
                addLabelClasses="text-muted font-weight-bold"
                :disabled="!selectedProductId"
                :value.sync="selectedProductValue"
                @update:value="() => {}" 
              />
              <CButton
                color="success"
                variant="outline"
                size="sm"
                class="mt-2 mb-3"
                :disabled="!selectedProductId"
                @click="event => addProductToCart()">
                <i class="bi bi-cart-check h4"></i>
              </CButton>
              <CButton 
                color="info" 
                variant="outline" 
                size="sm" class="ml-1 mt-2 mb-3"
                :disabled="!selectedProductId"
                @click="event => openRightSidebarProductDetail(event)">
                <i class="bi bi-journal-text h4"></i>
              </CButton>
              <!-- <CButton 
                color="primary" 
                variant="outline" 
                size="sm" 
                class="ml-1 mt-2 mb-3"
                :disabled="!selectedProductId" 
                @click="event => openRightSidebarProductCost(event)">
                <i class="bi bi-cash-coin h4"></i>
              </CButton> -->
            </CCol>
          </CRow>

          <!-- <CCol sm="2">
            <CInput
              type="text"
              label="Costo"
              addLabelClasses="text-muted font-weight-bold text-capitalize"
              :disabled="!quoteForm['directorio']"
              :class="!quoteForm['directorio'] ? 'disabled' : ''"
              :value.sync="selectedProductCost"
              @update:value="() => {}" />
          </CCol> -->
          <!-- <CCol sm="1">
            <CInput
              type="text"
              label="Margen"
              addLabelClasses="text-muted font-weight-bold text-capitalize"
              :disabled="!quoteForm['directorio']"
              :class="!quoteForm['directorio'] ? 'disabled' : ''"
              :value.sync="selectedProductMargin"
              @blur="() => {
                const result = parseFloat(selectedProductCost) / ((100 - selectedProductMargin) / 100)
                selectedProductValue = parseFloat(result.toFixed(2))
                // getProduct().then(res => {
                //   selectedProduct = res
                //   const result = parseFloat(selectedProductCost) / ((100 - selectedProductMargin) / 100)
                //   selectedProductValue = parseFloat(result.toFixed(2))
                // })
              }"
              @update:value="() => {}" />
          </CCol> -->


          <CDataTable
            :items="products"
            :fields="fields"
            :items-per-page="10"
            :pagination="true"
            hover>
            <template #cantidad="{item}">
              <td >
                <CInput
                  onkeydown="return !isNaN(Number(event.key)) || event.key == 'ArrowRight' || event.key == 'ArrowLeft' || event.key == 'ArrowDown' || event.key == 'ArrowUp' || (parseInt(event.target.value/10) > 1)"
                  @input="(value) => { 
                  //updateQuantity(value, item) 
                    updateCosts()
                  }"
                  :value.sync="item['cantidad']"
                  min="1"
                  type="number"/>
              </td>
            </template>
            <template #vrUnidad="{item}">
              <td align="right">
                <CInput
                  onkeydown="return !isNaN(Number(event.key)) || event.key == 'ArrowRight' || event.key == 'ArrowLeft' || event.key == 'ArrowDown' || event.key == 'ArrowUp' || (parseInt(event.target.value/10) > 1)"
                  @input="(value) => { 
                  //updateProductPriceInCart(value, item) 
                  }"
                  :value.sync="item['valor_Producto']"
                  type="text"/>
                  <span v-if="item.iva_Incluido && item.iva_Incluido === 'V'">{{formatter.format(coefAccIVA(item).realCost)}}</span>
              </td>
            </template>
            <template #vrTotal="{item}">
              <td class="text-right">
                {{ formatter.format((coefAccIVA(item).realCost) * parseFloat(item['cantidad']), 2) }}
              </td>
            </template>
            <template #acciones="{item, index}">
              <td>
                <CRow>
                  <CCol sm="6">
                    <a href="#"
                      class="text-dark"
                      @click="(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        toggleComments(item, index)
                      }">
                      <CIcon name="cil-comment-square"></CIcon>
                    </a>
                  </CCol>
                  <CCol sm="6">
                    <a href="#" 
                      class="text-danger"
                      @click="(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        deleteItem(item, index);
                      }">
                      <CIcon name="cil-trash"></CIcon>
                    </a>
                  </CCol>
                </CRow>
              </td>
            </template>
            <template #details="{item}">
              <CCollapse :show="Boolean(item._toggled)" class="mt-2 p-3" sm="12">
                <CTextarea 
                  label="Comentarios: "
                  v-on:keyup="updateComments($event, item)"
                  :value.sync="item['comentarios']"
                  :description="(item['comentarios'] ? item['comentarios'] : '').length+ ' carácteres'"/>
              </CCollapse>
            </template>
          </CDataTable>
        </CCardBody>

        <CElementCover v-show="loading"/>
      </CCard>

      <RightSideBar :show="showRightSidebarDependency" class="bg-white">
        <vertical-dynamic-form title="Dependencia / CenCos" :fields="dependency_fields" />
        <div class="d-flex justify-content-center">
          <CButton 
            color="success" 
            @click="$event => saveDependency()">
            <CIcon name="cil-check-circle" />
            <span class="align-middel mx-2">Guardar</span>
          </CButton>
          <CButton 
            color="danger" 
            variant="outline" 
            class="d-inline-block ml-2" 
            @click="(e) => {
              e.stopPropagation();
              e.defaultPrevented = true;

              showRightSidebarDependency = false
            }">
            <CIcon name="cil-x-circle" />
            <span class="align-middle mx-2">Cancelar</span>
          </CButton>
        </div>
      </RightSideBar>

      <RightSideBar :show="showRightSidebarProductDetail" class="bg-white">
        <vertical-dynamic-form title="Datos de compra" :fields="productDetail_fields" />
        <div class="d-flex justify-content-center">
          <CButton 
            color="success" 
            @click="$event => asignProductDetails()">
            <CIcon name="cil-check-circle" />
            <span class="align-middel mx-2">Guardar</span>
          </CButton>
          <CButton 
            color="danger" 
            variant="outline" 
            class="d-inline-block ml-2" 
            @click="(e) => {
              e.stopPropagation();
              e.preventDefault();

              showRightSidebarProductDetail = false
            }">
            <CIcon name="cil-x-circle" />
            <span class="align-middle mx-2">Cancelar</span>
          </CButton>
        </div>
      </RightSideBar>

      <RightSideBar :show="showRightSidebarProductCost" class="bg-white">
        <div class="d-flex justify-content-center">
          <CButton 
            color="success" 
            @click="$event => asignProductDetails()">
            <CIcon name="cil-check-circle" />
            <span class="align-middel mx-2">Guardar</span>
          </CButton>
          <CButton 
            color="danger" 
            variant="outline" 
            class="d-inline-block ml-2" 
            @click="(e) => {
              e.stopPropagation();
              e.preventDefault();

              showRightSidebarProductCost = false
            }">
            <CIcon name="cil-x-circle" />
            <span class="align-middle mx-2">Cancelar</span>
          </CButton>
        </div>
      </RightSideBar>

      <CModal
        title=""
        color="dark"
        :show.sync="confirmationModal"
        :centered="true"
        :closeOnBackdrop="false"
        :backdrop="true">
            <template v-slot:header>
              <h4>{{isCreate ? 'Agregar' : 'Editar'}} Cotización</h4>
            </template>
            <template v-slot:body-wrapper>
              <CContainer class="d-flex justify-content-center p-4">                    
                <p>
                  ¿Confirma que desea {{ isCreate ? 'agregar' : 'editar' }} esta Cotización?                   
                </p>
              </CContainer>
            </template>
            <template v-slot:footer>
              <CContainer class="d-flex justify-content-center">
                <CButton
                  color="success"
                  square 
                  class="mr-2 d-inline-block"
                  @click="isCreate ? createQuote() : updateQuote()">
                  <CIcon name="cil-check-circle"></CIcon>
                  <span class="p-2 align-middle">Aceptar</span>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  square 
                  class="mr-2 d-inline-block"
                  @click="confirmationModal=false">
                  <CIcon name="cil-x-circle"></CIcon>
                  <span class="p-2 align-middle">Cancelar</span>
                </CButton>
              </CContainer>
            </template>
      </CModal>

      <CModal
        title="Agregar Correo Electrónico"
        color="dark"
        :show.sync="eMailsModal"
        :centered="true"
        :closeOnBackdrop="false"
        :backdrop="true">
        <template v-slot:body-wrapper>
          <CContainer class="pt-3 mb-2">
            <CRow>
              <CCol sm="10">
                <CInput
                  type="email"
                  label="Correo Electrónico"
                  addLabelClasses="text-muted font-weight-bold text-capitalize"
                  :value.sync="additionalMailValue"
                  @update:value="() => {}" />
              </CCol>
              <CCol>
                <CButton
                  color="success"
                  class="mt-4" 
                  @click="addAdditionalMail()" >
                  <CIcon name="cil-plus"></CIcon>
                </CButton>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CListGroup v-if="additionalseMails.length">
                  <CListGroupItem v-for="(email, index) in additionalseMails" :key="index">
                    <a href="#" @click="deleteAdditionalMail(idx)">
                      <CIcon name="cil-trash" class="text-danger mr-2"></CIcon>
                    </a>
                    {{ email }}
                  </CListGroupItem>
                </CListGroup>
              </CCol>
            </CRow>
          </CContainer>
        </template>
        <template v-slot:footer>
          <CContainer class="d-flex justify-content-center">
            <CButton
              color="info"
              variant="outline"
              class="mr-2 d-inline-block"
              @click="eMailsModal=false">
              <CIcon name="cil-check-circle"></CIcon>
              <span class="p-2 align-middle">Aceptar</span>
            </CButton>
          </CContainer>
        </template>
      </CModal>
  </CContainer>
</template>
<script>
  import moment from 'moment'
  import { uuid } from 'vue-uuid'

  import constants from "@/constants";
  import { 
    coefAccIVA, 
    coefConsTax, 
    formatter, 
    errorMessage
  } from "@/general";
  import {
    searchDirectorio,
    searchProductos,
    dataListCiudades, 
    dataListDependencias, 
    grabaCotizacion,
    dataProducto,
    obtenerCotizacion,
    actualizaCotizacion,
    guardarDependencia
  } from "@/api";
  
  import CAutocomplete from '../../containers/CAutocomplete'
  import RightSideBar from '../../containers/RightSideBar.vue'
  import VerticalDynamicForm from '../../containers/VerticalDynamicForm.vue'

  const fields = [
    { 
        key: 'codigo', 
        label: 'Código', 
        _style:'text-align:center;'
    },
    { 
        key: 'descripcion', 
        label: 'Descripción', 
        _style:'text-align:center;'
    },
    {
      key: "marca",
      label: "Marca",
      _style: "text-align:center;"
    },
    { 
        key: 'cantidad', 
        label: 'Cantidad',
        _style: 'text-align:center;'
    },
    { 
        key: 'vrUnidad', 
        label: 'Valor', 
        _style:'text-align:center;'
    },
    { 
        key: 'vrTotal', 
        label: 'Total', 
        _style:'text-align:center;'
    },
    { 
        key: 'acciones', 
        label: '', 
        _style: 'width:10%;text-align:center;'
    }
  ]

  export default {
    name: 'QuoteForm',
    data() {
      return {
        fields,
        formatter,
        moment,
        uuid,
        loading: false,
        rootPath: "",
        showRightSidebarDependency: null,
        showRightSidebarProductDetail: null,
        showRightSidebarProductCost: null,
        eMailsModal: null,
        confirmationModal: null,
        isCreate: false,
        dependency_fields: [
          {
            key: "dependencia",
            value: "",
            type: "text",
            label: "Dependencia",
            required: true
          },
          {
            key: "contacto",
            value: "",
            type: "text",
            label: "Contacto",
            required: true
          },
          {
            key: "establecimiento",
            value: "",
            type: "text",
            label: "Establecimiento"
          },
          {
            key: "tipo_telefono",
            value: "",
            type: "select",
            options: [
              { value: "G", label: "General" },
              { value: "T", label: "Trabajo" },
              { value: "M", label: "Movil" },
              { value: "P", label: "Personal" },
              { value: "F", label: "Fax" }
            ],
            label: "Tipo Teléfono",
            prepend_content: {
              name: "journal-bookmark"
            }
          },
          {
            key: "telefono",
            value: "",
            type: "text",
            prepend_content: {
              name: "telephone"
            },
            label: "Teléfono",
            required: true
          },
          {
            key: "extension",
            value: "",
            type: "text",
            label: "Extensión"
          },
          {
            key: "direccion",
            value: "",
            type: "text",
            label: "Dirección",
            required: true
          },
          {
            key: "ciudad",
            value: "",
            type: "autocomplete",
            options: [],
            label: "Ciudad",
            required: true
          },
          {
            key: "correo_electronico",
            value: "",
            type: "text",
            label: "Correo Electrónico",
            required: true
          },
          {
            key: "codigo",
            value: "",
            type: "text",
            label: "Código"
          },
          {
            key: "habilitado_pedidos",
            value: "",
            type: "switch",
            label: "Habilitado Pedidos"
          }
        ],
        productDetail_fields: [
          {
            key: "precio_compra",
            value: "",
            type: "text",
            label: "Precio de Compra:",
            prepend_content: {
              name: "cash-coin"
            }
          },
          {
            key: "porcentaje_utilidad",
            value: "",
            type: "text",
            label: "Porcentaje Utilidad:",
            prepend_content: {
              name: "percent"
            }
          },
          {
            key: "tipo_moneda",
            value: "",
            type: "select",
            options: [
              { value: "COP", label: "Peso Colombiano"},
              { value: "USD", label: "Dollar Americano"}
            ],
            label: "Tipo Moneda de Compra:",
            prepend_content: {
              name: "currency-exchange"
            }
          },
          {
            key: "proveedor",
            value: "",
            type: "text",
            label: "Proveedor:",
            prepend_content: {
              name: "person-workspace"
            }
          },
          {
            key: "numero_parte",
            value: "",
            type: "text",
            label: "No. Parte:",
            prepend_content: {
              name: "tag"
            }
          },
          {
            key: "observaciones",
            value: "",
            type: "textarea",
            label: "Observaciones:",
            prepend_content: {
              name: "chat-right-text"
            }
          }
        ],
        pursharseOrder: '',
        comments1: '',
        comments2: '',
        additionalMailValue: "",
        additionalseMails: [],
        buyOrderFile: [],
        directory: [],
        dependencies: [],
        productsList: [],
        citiesList: [],
        products: [],
        quoteForm: {
          directorio: '',
          dependencia: '',
          Dias_Validez: 1
        },
        selectedProduct: {},
        selectedProductId: '',
        selectedProductQty: 0,
        selectedProductCost: 0,
        selectedProductMargin: 0,
        selectedProductValue: 0,
        productsCost: 0,
        IVACost: 0,
        consTax: 0,
        totalCost: 0,
        selectedProductDetail: "Datos NO disponibles"
      }
    },
    components: {
      CAutocomplete,
      RightSideBar,
      VerticalDynamicForm
    },
    methods: {
      coefAccIVA,
      coefConsTax,
      openRightSidebarDependency(event) {
        event.stopPropagation()

        this.dependency_fields[0].value = ""
        this.dependency_fields[1].value = ""
        this.dependency_fields[2].value = ""
        this.dependency_fields[3].value = "G"
        this.dependency_fields[4].value = ""
        this.dependency_fields[5].value = ""
        this.dependency_fields[6].value = ""
        this.dependency_fields[8].value = ""
        this.dependency_fields[9].value = ""
        this.dependency_fields[10].value = false

        this.showRightSidebarDependency = true
      },
      openRightSidebarProductDetail(event) {
        event.stopPropagation()
        
        this.productDetail_fields[0].value = this.selectedProductCost
        this.productDetail_fields[2].value = "COP"

        console.log(this.selectedProductValue);

        if (this.selectedProductValue > 0) {
          const cost = this.selectedProductCost
          const price = parseFloat(this.selectedProductValue)
          const margin = (100 - ((cost * 100) / price))

          this.productDetail_fields[1].value = margin.toFixed(2)
        }

        this.showRightSidebarProductDetail = true
      },
      openRightSidebarProductCost(event) {
        event.stopPropagation()

        this.showRightSidebarProductCost = true
      },
      generateProductInfo(data) {
        this.selectedProductDetail = `<table class="table table-borderless table-sm text-left text-success"><tbody>
                    <tr>
                      <td>Codigo</td>
                      <td>${data.codigo}</td>
                    </tr>
                    <tr>
                      <td>Marca</td>
                      <td>${data.marca}</td>
                    </tr>
                    <tr>
                      <td>Tarifa IVA</td>
                      <td>${data.tarifa_IVA}%</td>
                    </tr>
                    <tr>
                      <td>Costo Promedio</td>
                      <td>$${formatter.format(data.costo_Promedio)}</td>
                    </tr>
                    <tr>
                      <td>Costo Reposici&oacute;n</td>
                      <td>$${formatter.format(data.costo_Reposicion)}</td>
                    </tr>
                    <tr>
                      <td>Saldo Inventario</td>
                      <td>${data.unidades_Disponibles}</td>
                    </tr>
                  </tbody></table>`
      },
      asignProductDetails(){
        const cost = parseFloat(this.productDetail_fields[0].value)
        const margin = parseFloat(this.productDetail_fields[1].value)
        const price = (cost / ((100 - margin) / 100))

        this.selectedProductCost = this.productDetail_fields[0].value
        this.selectedProductValue = price.toFixed(2)

        this.showRightSidebarProductDetail = false
      },
      addProductToCart() {
        if (!this.selectedProductId || !this.selectedProductQty || !this.selectedProductValue) {
          const fieldName = !this.selectedProductId ? "Producto" : !this.selectedProductQty ? "Cantidad" : !this.selectedProductValue ? "Cantidad" : ""
          this.$store.commit(
            "setAlert", {
              color: "warning",
              message: `El campo ${fieldName} no puede estar vacio!`,
              show: 5
            }
          )

          return
        }

        // const product = await this.getProduct()
        // product["cantidad"] = this.selectedProductQty
        // product["valor_Producto"] = this.selectedProductValue
        // product["comentarios"] = ""

        // this.products.push(product)

        this.selectedProduct["cantidad"] = this.selectedProductQty
        this.selectedProduct["valor_Producto"] = this.selectedProductValue
        this.selectedProduct["comentarios"] = ""

        this.selectedProduct["nombre_Proveedor"] = this.productDetail_fields[3].value,
        this.selectedProduct["valor_Proveedor"] = this.productDetail_fields[0].value,
        this.selectedProduct["tipo_Moneda"] = this.productDetail_fields[2].value,
        this.selectedProduct["numero_Parte"] = this.productDetail_fields[4].value,
        this.selectedProduct["observaciones"] = this.productDetail_fields[4].value

        this.products.push(this.selectedProduct)

        this.selectedProductId = ""
        this.selectedProductQty = 0
        this.selectedProductCost = 0
        this.selectedProductValue = 0

        this.productDetail_fields.map(item => {
          item.value = ""
        })

        this.productsList.length = 0

        // this.$store.dispatch('addProductToCart', product)

        this.updateCosts()
        this.calculateIVACost()
        this.calculateConsTax()
        this.calculatedTotal()
      },
      deleteItem(product, index) {
        product
        this.products.splice(index, 1)

        // this.$store.commit('popProductFromCart', product)
        // this.$store.commit('calculateProductsCost')
        // this.$store.commit('calculateIVACost')
        // this.$store.commit('calculateConsTax')

        this.updateCosts()
        this.calculateIVACost()
        this.calculateConsTax()
        this.calculatedTotal()
      },
      updateQuantity(){
        // let fValue = 0
        // if (value.toString().length && (Number(value) > 0)) {
        //     fValue = value                
        // } else {
        //     const sItem = this.cart.items.find(product => item['id_Producto'] === product['id_Producto'])
        //     sItem['cantidad'] = 1
        //     this.$set(sItem, 'cantidad', 1)
        //     this.$nextTick(() => { })
        // }

        // this.$store.commit('updateItemQuantity', [
        //         fValue,
        //         item
        //     ])
        // this.$store.commit('calculateProductsCost')
        // this.$store.commit('calculateIVACost')
        // this.$store.commit('calculateConsTax')  

        this.updateCosts()
        this.calculateIVACost()
        this.calculateConsTax()
        this.calculatedTotal()
      },
      updateProductPriceInCart(){
        // this.$store.commit('updateProductPriceInCart', [
        //   value,
        //   item
        // ])
        // this.$store.commit('calculateProductsCost')
        // this.$store.commit('calculateIVACost')
        // this.$store.commit('calculateConsTax')
        this.updateCosts()
        this.calculateIVACost()
        this.calculateConsTax()
        this.calculatedTotal()
      },
      updateCosts() {
        this.productsCost = this.products.reduce(((acc, item) => {
            return parseFloat(acc) + (coefAccIVA(item).realCost * parseFloat(item['cantidad']))
        }), 0)
      },
      calculateIVACost() {     
        this.IVACost = this.products.reduce(((acc, item) => {
            return parseFloat(acc) + (parseFloat(item['cantidad']) * coefAccIVA(item).ivaTax)
        }), 0) 
      },
      calculateConsTax() {
        this.consTax = this.products.reduce(((acc, item) => {
          return parseFloat(acc) + (parseFloat(item['cantidad']) * coefConsTax(item))
        }), 0) 
      },
      calculatedTotal() {
        this.totalCost = this.productsCost + this.IVACost + this.consTax
      },
      resetCart() {
        this.$store.commit("set", ["quote", this.quote])
        this.$nextTick(() => { })
        this.$store.commit('resetCart')
        this.$store.commit('resetQuote')
        this.$store.commit('set', ['quoteActiveTab', 0])

        this.$router.push({ path: this.rootPath });
      },
      addAdditionalMail() {
        if (this.additionalMailValue) {
          this.additionalseMails.push(this.additionalMailValue)
          this.additionalMailValue = ""
        }
      },
      deleteAdditionalMail(idx) {
        this.additionalseMails.splice(idx, 1)
      },
      async getQuote() {
        try {
          const { response } = await obtenerCotizacion(
            this,
            this.$store.state.selectedQuote
          )

          return response
        } catch(error) {
          this.$store.commit(
            'setAlert',
            {
              color: "danger",
              message: 'Error al cargar datos',
              show: 5
            }
          )
        }
      },
      async createQuote() {
        this.loading = true

        try {
          this. confirmationModal = false
          
          await grabaCotizacion(
            this,
            this.quoteForm.directorio,
            this.quoteForm.dependencia,
            parseInt(this.quoteForm.Dias_Validez),
            this.products,
            this.comments1,
            this.comments2
          )

          this.resetCart();

          this.$store.commit("setAlert", {
            color: "success",
            message: constants.messages.successfulAction,
            show: 5 
          });
        } catch(error) {
          console.log(error)
          this.$store.commit("setAlert", {
            color: "danger",
            message: errorMessage(error),
            show: 5 
          });
        } finally {
          this.loading = false
        }
      },
      async updateQuote(){
        this.loading = true;

        try {
          this. confirmationModal = false
          
          await actualizaCotizacion(
            this,
            this.$store.state.selectedQuote,
            this.quoteForm.directorio,
            this.quoteForm.dependencia,
            parseInt(this.quoteForm.Dias_Validez),
            this.products,
            this.comments1,
            this.comments2
          )

          this.resetCart();

          this.$store.commit("setAlert", { 
            color: "success",
            message: constants.messages.successfulAction,
            show: 5 
          });
        } catch(error) {
          console.log(error)
          this.$store.commit("setAlert", {
            color: 'danger',
            message: errorMessage(error),
            show: 5 
          });
        } finally {
          this.loading = false
        }
      },
      async getDirectoryData(value){
        if (value.length > 2) {
          try {
            const response = await searchDirectorio(this, value)
            this.directory = response.map(item => {
              return {
                value: item.id_Directorio,
                label: `${item.empresa} - ${item.identificacion}`
              }
            })
          } catch (error) {
            this.$store.commit(
              'setAlert',
              {
                color: "danger",
                message: 'Error al cargar datos',
                show: 5
              }
            )
          }
        }
      },
      async getDependencies(idDirectory) {
        try {
          const response = await dataListDependencias(this, idDirectory)

          this.dependencies.length = 0
          this.dependencies = response.map(item => {
            return {
              value: item.id_Dependencia,
              label: `${item.dependencia} - ${item.responsable}`
            }
          })
        } catch (error) {     
          console.log(error);     
          this.$store.commit("setAlert", {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          });
        }
      },
      async getProductsList(value){
        if (value.length > 2) {
          try {
            const response = await searchProductos(this, value)
            this.productsList = response.map(item => {
              return {
                value: item.id_Producto,
                label: `${item.codigo} - ${item.descripcion}`
              }
            })
          } catch (error) {
            this.$store.commit(
              'setAlert',
              {
                color: "danger",
                message: 'Error al cargar datos',
                show: 5
              }
            )
          }
        }
      },
      async getProduct() {
        try {
          this.loading = true

          const [response] = await dataProducto(this, this.selectedProductId)
          this.selectedProduct = response

          console.log(response);
          console.log(this.selectedProduct);

          this.selectedProductCost = response.costo_Promedio

          this.generateProductInfo(response)

          // return response
        } catch (error) {
          this.$store.commit(
            'setAlert',
            {
              color: "danger",
              message: `Ocurrio un Error al cargar datos. Error ${error.status} - ${error.statusText}`,
              show: 5
            }
          )
        } finally {
          this.loading = false
        }
      },
      async saveDependency(){
        this.loading = true

        try {
          const dependency = {
            directorio: this.quoteForm.directorio,
            dependencia: this.dependency_fields[0].value,
            responsable: this.dependency_fields[1].value,
            establecimiento: null,
            tipo_Telefono: this.dependency_fields[3].value,
            telefono: this.dependency_fields[4].value,
            extension: this.dependency_fields[5].value,
            direccion: this.dependency_fields[6].value,
            ciudad: this.dependency_fields[7].value,
            correo_Electronico: this.dependency_fields[8].value,
            codigo: this.dependency_fields[9].value,
            habilitado_Pedidos: this.dependency_fields[10].value===true ? "V" : "F",
            activar_Presupuesto: "F",
            valor_Presupuesto: 0,
            estado: "A"
          }
          Object.keys(dependency).forEach(key => {
            dependency[key] ? null : delete dependency[key]
          })          

          console.log(dependency);

          await guardarDependencia(
            this,
            dependency
          )

          await this.getDependencies(this.quoteForm.directorio)

          this.$store.commit('setAlert', {
            color: "success",
            message: 'Acción exitosa',
            show: 5
          })

          this.showRightSidebarDependency = false
        } catch (error) {
          console.log(error)
          this.$store.commit('setAlert', {
            color: "danger",
            message: constants.messages.notDoneAdd,
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async getCitiesList() {
        try {
          const response = await dataListCiudades(this)
          const citiesList = [
            {
              value: "",
              label: "Seleccionar"
            },
            ...response.map(item => {
              return {
                value: item.id_Ciudad,
                label: `${item.ciudad} - ${item.departamento}`
              }
            })
          ]

          return citiesList
        } catch (error) {     
          console.log(error);     
          this.$store.commit(
            "setAlert",
            {
              color: "danger",
              message: "Error al cargar los datos de ciudades.",
              show: 5
            }
          )
        }
      },
      toggleComments(item){
        // const sItem = this.cart.items.find(product => item['id_Producto'] === product['id_Producto'])
        this.$set(item, '_toggled', !item._toggled)
        this.$nextTick(() => { })
      },
      updateComments(event, product){
        const text_size = (event.target._value.toString()).length
        if (text_size > 500) {
          this.$store.commit('updateItemComments', [
                      (event.target._value.toString()).slice(0, 500),
                      product
                  ])
          
        } else {
          this.$store.commit('updateItemComments', [
                      event.target._value,
                      product
                  ])
        }
      },
      fileChange(files){
          this.buyOrderFile = files
      }
    },
    async mounted() {
      this.loading = true

      const splittedPath = this.$router.currentRoute.fullPath.split("/");
      const action = splittedPath[splittedPath.length - 1];

      this.rootPath = this.$router.currentRoute.fullPath.replace(`/${action}`, "");
      this.isCreate = action === "agregar";

      this.dependency_fields[7].options = await this.getCitiesList()

      if (!this.isCreate) {
        const quoteData = await this.getQuote()

        await this.getDirectoryData(quoteData.empresa)

        this.comments1 = quoteData.comentario_01 || ""
        this.comments2 = quoteData.comentario_02 || ""
        this.quoteForm.directorio = quoteData.id_Directorio

        // this.dependencies = quoteData.id_Directorio ? [...await this.getDependencies(quoteData.id_Directorio)] : []

        this.quoteForm.dependencia = quoteData.id_Dependencia ? quoteData.id_Dependencia : ""
        this.quoteForm.Dias_Validez = quoteData.dias_Validez
        this.products = quoteData.productos
        this.productsCost = quoteData.valor_Mercancia
        this.IVACost = quoteData.valor_Iva
        this.consTax = quoteData.valor_ImpConsumo
        this.totalCost = quoteData.valor_Total
      }

      this.loading = false

      // if (this.quote['directorio']) {
      //   this.directory = [await this.getDirectory(this.quote['directorio'])]
      //   this.dependencies = [...await this.getDependencies(this.quote['directorio'])]
      //   Object.keys(this.quote).forEach((key) => {   
      //     this.quoteForm[key] = this.quote[key]
      //     this.$set(this.quoteForm, key, this.quote[key])
      //     this.$nextTick(() => { })     
      //   })
      // }
    },
    computed: {
      cart() {
        return this.$store.state.cart
      },
      quote() {
        return this.$store.state.quote
      },
      dependency() {
        return this.$store.state.user.dependency
      },
      cartSize() {
        return this.products.reduce(((acc, item) => {return Number(acc) + Number(item['cantidad'])}), 0)
      },
      dateValid() {
        return moment().add(this.quoteForm['Dias_Validez'], 'days').format('DD/MM/YYYY')
      }
    }
  }
</script>